import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import {getTeamNamesOfGames} from 'helpers/game-helper';

class AllGamesChecking extends Component {
    constructor(props) {
        super(props);

        this.setTeamNames(props.games.getAllAsArr());
    }

    componentDidUpdate(props) {
        this.setTeamNames(props.games.getAllAsArr());
    }

    setTeamNames(games) {
        const {sportConfig} = this.props;

        this.lockedTeamNames = [];
        this.allTeamNames = getTeamNamesOfGames(games);

        if (sportConfig.isModeLateswap()) {
            const lockedGames = games.filter((game) => game.isLocked);

            this.lockedTeamNames = getTeamNamesOfGames(lockedGames);
        }
    }

    onChange(isChecked) {
        const teams = isChecked ? [...this.allTeamNames] : [...this.lockedTeamNames];
        this.props.dispatch(Action.set('GamesFilter', teams));
    }

    isChecked() {
        const {playersFilter, games} = this.props;
        const selectedTeamsQuantity = playersFilter.games.length;
        const allTeamsQuantity = 2 * games.getGamesQuantity();

        return selectedTeamsQuantity === allTeamsQuantity;
    }

    render() {
        return (
            <label className="game-filter-all">
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={this.isChecked()}
                    className="form-control"
                />
                <span>All games</span>
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {games, filters},
        sportConfig,
    } = state;

    return {
        games,
        playersFilter: filters,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(AllGamesChecking);
